import { useRef } from 'react'
import { Stack } from '@mui/material'
import { Timestamp } from '@weblite/ts-action/types'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { RawImageMessage } from '@weblite/ts-action/message'
import { t } from '$i18n'
import { toLocale } from '$func/text'
import { MediaCard } from '$common/media-card'
import { AppBarBackTitleActionMenu } from '$common/app-bar/app-bar-back-title-action-menu'
import { nothing } from '$func/utils'

export interface ImageDetails {
  src?: string
  description?: string
  owner?: {
    id: string
    type: 'USER' | 'WAPP' | 'CHANNEL'
  }
  date?: Timestamp
  functions?: {
    onDownload?: () => unknown
    onShare?: () => unknown
    onRemove?: () => unknown
    onForward?: () => unknown
    onShowSharedMedia?: () => unknown
    onEdit?: () => unknown
  }
  attachment?: RawImageMessage['attachment']
}

interface Props {
  total?: number
  current?: number
}

export function MediaViewerLoader({ total, current }: Props) {
  const cardRef = useRef<HTMLDivElement>(null)
  const captionRef = useRef<HTMLDivElement>(null)
  const appbarRef = useRef<HTMLDivElement>(null)
  const imageContainerRef = useRef<HTMLDivElement>(null)

  return (
    <MediaCard
      onClick={nothing}
      appbarRef={appbarRef}
      appbarComponent={
        <AppBarBackTitleActionMenu
          title={
            current && total
              ? `${toLocale(current)} ${t('common.from')} ${toLocale(total)}`
              : ''
          }
          onBack={closeCurrentModal}
          functions={{}}
        />
      }
      cardRef={cardRef}
    >
      <Stack
        ref={imageContainerRef}
        sx={{
          position: 'absolute',
          marginTop: 0,
          marginRight: 0,
          visibility: 'hidden',
          width: '100%',
          height: '100%',
        }}
      />

      <Stack
        ref={captionRef}
        sx={{
          position: 'absolute',
          bottom: 0,
          backgroundColor: '#00000080',
          width: '100%',
        }}
        onClick={e => e.stopPropagation()}
      />
    </MediaCard>
  )
}

MediaViewerLoader.defaultProps = {
  total: null,
  current: null,
}
